import Enum from 'enum';
import { Map } from 'immutable';
import { extractIndex, extractContactName } from 'flow/utils/extension-utils';
import { extractPbxIndex } from 'flow/utils/pbx-utils';
import { sortStrings } from 'flow/utils/sorter-utils';

/**
 * Represents the different types a favorite can be presented as
 * @type {Enum}
 */
export const FavoriteType = new Enum({
    extension: 'extension',
    contact: 'contact',
    queue: 'queue',
    refer: 'refer',
});

/**
 * Check if the supplied key is a FavoriteEntityKey.
 * @param key the entity key
 * @return true if the supplied key matches FavoriteEntityKey format
 */
export const isFavoriteKey = (key) => /^favorite-[0-9]+$/.test(key);

export const isFavoriteType = (favoriteTypeString) => {
    if (typeof favoriteTypeString !== 'string') {
        return false;
    }
    return !!FavoriteType.get(favoriteTypeString);
};

export const isFavoriteDTO = (favoriteDTO) => {
    if (favoriteDTO) {
        const keyHasCorrectFormat = /^favorite-[0-9]+$/.test(
            favoriteDTO.get('key'),
        );
        const typeIsOfFavoriteType = isFavoriteType(favoriteDTO.get('type'));
        const hasFavoriteData = !!favoriteDTO.get('favoriteData');
        return keyHasCorrectFormat && typeIsOfFavoriteType && hasFavoriteData;
    } else {
        return false;
    }
};

export const sortFavorites = (favorites) => {
    if (!favorites || favorites.isEmpty()) {
        return Map();
    }
    const sortedFavorites = favorites.sort((favorite1, favorite2) => {
        const string1 = extractComparableFavoriteString(favorite1);
        const string2 = extractComparableFavoriteString(favorite2);
        return sortStrings(string1, string2);
    });
    return sortedFavorites;
};

const extractComparableFavoriteString = (favorite) => {
    if (favorite) {
        const favoriteData = favorite.get('favoriteData');
        switch (favorite.get('type')) {
            case FavoriteType.extension.key:
                return extractIndex(favoriteData);
            case FavoriteType.contact.key:
                return extractContactName(favoriteData);
            case FavoriteType.queue.key:
                return extractPbxIndex(favoriteData);
            default:
                console.warn('Unknown favorite type:', favorite.get('type'));
                return '';
        }
    } else {
        return null;
    }
};
